import React from "react";

/*
    Warning Icon
*/

const WarningIcon = (props) => (
    <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 4C0 1.79086 1.79086 0 4 0H40V48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#FA9E00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.0539 15.6518L28.874 31.2933C29.266 32.0774 28.696 33 27.8195 33H12.1805C11.3041 33 10.734 32.0775 11.126 31.2934L18.9449 15.6519C19.3794 14.7827 20.6194 14.7827 21.0539 15.6518ZM19.9994 19.5478C20.447 19.5478 20.8099 19.9712 20.8099 20.4934V26.1672C20.8099 26.6895 20.447 27.1128 19.9994 27.1128C19.5517 27.1128 19.1888 26.6895 19.1888 26.1672V20.4934C19.1888 19.9712 19.5517 19.5478 19.9994 19.5478ZM20.8099 29.5444C20.8099 29.9921 20.447 30.355 19.9994 30.355C19.5517 30.355 19.1888 29.9921 19.1888 29.5444C19.1888 29.0968 19.5517 28.7339 19.9994 28.7339C20.447 28.7339 20.8099 29.0968 20.8099 29.5444Z"
            fill="white"
        />
    </svg>
);

export default WarningIcon;
